<ng-container *ngIf="!checked && questionNumber">{{ questionNumber }}</ng-container>
<mat-icon *ngIf="checked" fontSet="zefplayer" class="swiper-no-swiping">check</mat-icon>
